<script>
import axios from 'axios';
import AppSelect from '../../shared/AppSelect.vue';

export default {
  components: { AppSelect },
  data() {
    return {
      roster_formats: [],
    }
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    customClass: {
      type: [String, Object],
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    options() {
      return this.roster_formats.map((format) => ({
        value: String(format.id),
        label: String(format.total_points),
      }));
    },
  },
  methods: {
    getList() {
      const url = "/api/dict/v1/roster_formats";
      axios.get(url, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }).then(response => {
        this.roster_formats = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    },
    onChange(value) {
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<template>
  <AppSelect
    variant="events-form"
    :class="customClass"
    :model-value="modelValue"
    :options="options"
    placeholder="Не выбран"
    @update:model-value="$emit('update:modelValue', $event)"
    @change="onChange"
  />
</template>
